import { CreateOrder } from '@/types/api/order';
import { CustomerFormValues } from '@/types/customer-form-values';
import { apiClient } from '@/utils/axios';

export default {
  create: async (data: CreateOrder) => {
    const response = await apiClient.post<{ id: string }>('/orders', data);
    return response.data;
  },

  get: async (orderId: string) => {
    const response = await apiClient.get(`/orders/${orderId}`);
    return response.data;
  },

  cancel: async (orderId: string): Promise<void> => {
    const response = await apiClient.post(`/orders/${orderId}/cancel`);
    return response.data;
  },

  confirm: async (orderId: string): Promise<void> => {
    const response = await apiClient.post(`/orders/${orderId}/confirm`);
    return response.data;
  },

  place: async (orderId: string, paymentMethod: 'SWISH' | 'PAY_LATER'): Promise<{ paymentId?: string }> => {
    const response = await apiClient.post(`/orders/${orderId}/place`, { paymentMethod });
    return response.data;
  },

  updateCustomer: async (orderId: string, customer: CustomerFormValues): Promise<void> => {
    await apiClient.put(`/orders/${orderId}/customer`, customer);
  },
};
